import * as React from 'react';

export interface ARootViewProps {
    loading?: boolean;
}

export abstract class ARootView<P extends ARootViewProps, T> extends React.Component<P, T> {
    protected mainContentId = 'mainContent';
}
